<template>
  <div class="about">
    <h1>This is a home page</h1>
  </div>
</template>

<script>
import { games } from '../../public/wnbasim-latest.json'

export default {
  name: 'Home',
  data () {
    return { games }
  },
  created () {
    if (this.$route.params.id || this.$route.name !== 'home') return
    const { slug } = this.readyGames[this.readyGames.length - 1]
    this.$router.push({ name: 'game', params: { id: slug } })
  },
  computed: {
    readyGames () {
      return this.games.filter((item) => !!item.ready)
    },
  },
}
</script>
